export default __webpack_public_path__ + "static/media/expire-date-icon.5038c011.svg";